module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section-outer"
  }, [_c('spinner', {
    attrs: {
      "spinner-visible": _vm.spinnerVisible
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('section', [_c('h2', [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    class: {
      'fixed-top-left': _vm.panelFixed
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Planned")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Total Planned Income")]), _vm._v(" "), _c('td', {
    staticClass: "bg-success number"
  }, [_vm._v(_vm._s(_vm.totalIncomes))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total Allocated")]), _vm._v(" "), _c('td', {
    staticClass: "bg-outflows number"
  }, [_vm._v(_vm._s(_vm.grandTotals.alloc.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Planned Surplus")]), _vm._v(" "), _c('td', {
    staticClass: "number",
    class: {
      'text-success': (_vm.grandTotals.plannedSurplus > 0), 'text-danger': (_vm.grandTotals.plannedSurplus < 0)
    }
  }, [_vm._v(_vm._s(_vm.grandTotals.plannedSurplus.toFixed(2)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Actual")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Total Inflows This Month")]), _vm._v(" "), _c('td', {
    staticClass: "bg-success number"
  }, [_vm._v(_vm._s(_vm.grandTotals.inflows.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total Outflows This Month")]), _vm._v(" "), _c('td', {
    staticClass: "bg-outflows number"
  }, [_vm._v(_vm._s(_vm.grandTotals.outflows.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total Budget Balance")]), _vm._v(" "), _c('td', {
    staticClass: "number",
    class: {
      'text-success': (_vm.grandTotals.budgetBalance > 0), 'text-danger': (_vm.grandTotals.budgetBalance < 0)
    }
  }, [_vm._v(_vm._s(_vm.grandTotals.budgetBalance.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Actual Current Surplus")]), _vm._v(" "), _c('td', {
    staticClass: "number",
    class: {
      'text-success': (_vm.grandTotals.actualSurplus > 0), 'text-danger': (_vm.grandTotals.actualSurplus < 0)
    }
  }, [_vm._v(_vm._s(_vm.grandTotals.actualSurplus.toFixed(2)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('section', [_c('h2', [_vm._v("Income")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('draggable', {
    attrs: {
      "element": "tbody",
      "options": {
        handle: '.sort-income'
      }
    },
    on: {
      "update": function($event) {
        _vm.autoSave(_vm.income_sources, 'budget', 'save-order')
      }
    },
    model: {
      value: (_vm.income_sources),
      callback: function($$v) {
        _vm.income_sources = $$v
      },
      expression: "income_sources"
    }
  }, _vm._l((_vm.localIncomeSources), function(income) {
    return _c('tr', [_c('td', {
      staticClass: "btn-col has-control"
    }, [(_vm.budgetEditable) ? _c('i', {
      staticClass: "fa fa-fw fa-arrows icon-button sort-income"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "income-source",
      class: {
        'has-control': _vm.budgetEditable
      }
    }, [(income.progress >= 100 && _vm.budgetInCurrentMonth) ? _c('i', {
      staticClass: "fa fa-check-circle-o progress-icon"
    }) : _vm._e(), _vm._v(" "), (income.progress < 100 && _vm.budgetInCurrentMonth) ? _c('span', {
      staticClass: "progress-value"
    }, [_vm._v(_vm._s(Math.round(income.progress)) + "% ")]) : _vm._e(), _vm._v(" "), (_vm.budgetInCurrentMonth) ? _c('div', {
      staticClass: "progress-bar",
      style: ({
        width: income.progress + '%'
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "value-container"
    }, [(income.descEditable && _vm.budgetEditable) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (income.source),
        expression: "income.source"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "autofocus": ""
      },
      domProps: {
        "value": (income.source)
      },
      on: {
        "blur": function($event) {
          income.descEditable = false
        },
        "change": function($event) {
          _vm.autoSave(income, 'income', 'save')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          income.source = $event.target.value
        }
      }
    }) : _c('div', {
      on: {
        "click": function($event) {
          income.descEditable = true
        }
      }
    }, [_vm._v(_vm._s(income.source))])])]), _vm._v(" "), _c('td', {
      staticClass: "number col-amounts",
      class: {
        'has-control': _vm.budgetEditable
      },
      staticStyle: {
        "width": "120px"
      }
    }, [(_vm.budgetEditable) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (income.amount),
        expression: "income.amount"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "0.01",
        "name": "amount_alloc",
        "placeholder": "$ 0.00"
      },
      domProps: {
        "value": (income.amount)
      },
      on: {
        "change": function($event) {
          _vm.autoSave(income, 'income', 'save')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          income.amount = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _c('div', [_vm._v(_vm._s(income.amount))])]), _vm._v(" "), _c('td', {
      staticClass: "btn-col has-control"
    }, [(_vm.budgetEditable) ? _c('i', {
      staticClass: "fa fa-fw fa-remove icon-button",
      on: {
        "click": function($event) {
          _vm.deleteItem('income', income.id)
        }
      }
    }) : _vm._e()])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Total Planned")]), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.totalIncomes))]), _vm._v(" "), _c('th', {
    staticClass: "btn-col"
  }, [(_vm.budgetEditable) ? _c('i', {
    staticClass: "fa fa-fw fa-plus icon-button",
    attrs: {
      "title": "Add new income source"
    },
    on: {
      "click": _vm.addIncome
    }
  }) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Total Actual")]), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.totalActualIncome))]), _vm._v(" "), _c('th')])])], 1)])])])], 1), _vm._v(" "), _c('section', {
    staticClass: "categories"
  }, [_c('h2', [_vm._v("Budget")]), _vm._v(" "), (!_vm.localIsOffline) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 date-controls"
  }, [_c('div', {
    staticClass: "year-selector date-selector"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.changeBudgetYear(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "selected-date"
  }, [_vm._v(_vm._s(_vm.budget_year))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.changeBudgetYear(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info jump-to-current-month",
    on: {
      "click": _vm.jumpToCurrentMonth
    }
  }, [_vm._v("Jump to Current Month")]), _vm._v(" "), _c('div', {
    staticClass: "month-selector date-selector"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.decrementBudgetMonth
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "selected-date"
  }, [_vm._v(_vm._s(_vm.budgetMonthName))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.incrementBudgetMonth
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "budget-tables",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "btn-col"
  }, [(!_vm.localIsOffline) ? _c('div', [(!_vm.editCategories) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.editCategories = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.doneEditingBudget
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Done")])]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "col-cat"
  }, [_vm._v("Group/Category")]), _vm._v(" "), _c('th', {
    staticClass: "col-amounts"
  }, [_vm._v("Allocated")]), _vm._v(" "), _c('th', {
    staticClass: "col-amounts"
  }, [_vm._v("Carryover")]), _vm._v(" "), _c('th', {
    staticClass: "col-amounts"
  }, [_vm._v("Inflows")]), _vm._v(" "), _c('th', {
    staticClass: "col-amounts"
  }, [_vm._v("Outflows")]), _vm._v(" "), _c('th', {
    staticClass: "col-amounts"
  }, [_vm._v("Balance")])])]), _vm._v(" "), (_vm.localIsOffline) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Since you appear to be offline, we can't retrieve your current budget. The budget being displayed is the most recent locally saved copy " + _vm._s(_vm.budgetLastSaved) + ".")])])]) : _vm._e()]), _vm._v(" "), (_vm.editCategories) ? _c('form', _vm._l((_vm.masterGroupsLocal), function(group) {
    return (group.name != 'Surplus') ? _c('table', {
      staticClass: "table group-table"
    }, [_c('thead', [_c('tr', {
      staticClass: "group-heading"
    }, [_c('td', {
      staticClass: "btn-col has-control"
    }), _vm._v(" "), _c('th', [(group.name != 'Surplus' && _vm.budgetEditable && group.descEditable) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.name),
        expression: "group.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "step": "0.01",
        "name": "name",
        "placeholder": "[Group Name]"
      },
      domProps: {
        "value": (group.name)
      },
      on: {
        "change": function($event) {
          _vm.autoSave(group, 'group', 'save')
        },
        "blur": function($event) {
          group.descEditable = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.name = $event.target.value
        }
      }
    }) : _c('div', {
      on: {
        "click": function($event) {
          group.descEditable = true
        }
      }
    }, [_vm._v(_vm._s(group.name))])]), _vm._v(" "), _c('th', {
      attrs: {
        "colspan": "4"
      }
    })])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "5"
      }
    }, _vm._l((group.categories), function(cat) {
      return _c('div', [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cat.isSelected),
          expression: "cat.isSelected"
        }],
        attrs: {
          "type": "checkbox",
          "name": cat.id
        },
        domProps: {
          "checked": Array.isArray(cat.isSelected) ? _vm._i(cat.isSelected, null) > -1 : (cat.isSelected)
        },
        on: {
          "change": function($event) {
            _vm.autoSave(cat, 'budget', 'save-categories')
          },
          "__c": function($event) {
            var $$a = cat.isSelected,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$c) {
                $$i < 0 && (cat.isSelected = $$a.concat($$v))
              } else {
                $$i > -1 && (cat.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              cat.isSelected = $$c
            }
          }
        }
      }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(cat.description) + "\n\t\t\t\t\t\t\t\t\t")])])
    }))])])]) : _vm._e()
  })) : _c('draggable', {
    attrs: {
      "options": {
        handle: '.sort-group'
      }
    },
    on: {
      "update": function($event) {
        _vm.autoSave(_vm.groups, 'budget', 'save-order')
      }
    },
    model: {
      value: (_vm.groups),
      callback: function($$v) {
        _vm.groups = $$v
      },
      expression: "groups"
    }
  }, _vm._l((_vm.localGroups), function(group) {
    return _c('table', {
      staticClass: "table group-table"
    }, [_c('thead', [_c('tr', {
      staticClass: "group-heading"
    }, [_c('td', {
      staticClass: "btn-col has-control"
    }, [(group.categories && group.name != 'Surplus' && !_vm.localIsOffline) ? _c('i', {
      staticClass: "fa fa-fw fa-arrows icon-button sort-group",
      attrs: {
        "title": "Re-order this group"
      }
    }) : _vm._e()]), _vm._v(" "), _c('th', [(group.name != 'Surplus' && _vm.budgetEditable && group.descEditable) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.name),
        expression: "group.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "step": "0.01",
        "name": "name",
        "placeholder": "[Group Name]"
      },
      domProps: {
        "value": (group.name)
      },
      on: {
        "change": function($event) {
          _vm.autoSave(group, 'group', 'save')
        },
        "blur": function($event) {
          group.descEditable = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.name = $event.target.value
        }
      }
    }) : _c('div', {
      on: {
        "click": function($event) {
          group.descEditable = true
        }
      }
    }, [_vm._v(_vm._s(group.name))])]), _vm._v(" "), _c('th', {
      staticClass: "number",
      staticStyle: {
        "width": "120px"
      }
    }, [_vm._v(_vm._s(group.totalAlloc ? group.totalAlloc.toFixed(2) : ''))]), _vm._v(" "), _c('th', {
      staticClass: "number col-amounts"
    }, [_vm._v(_vm._s(group.totalCarryover.toFixed(2)))]), _vm._v(" "), _c('th', {
      staticClass: "number col-amounts"
    }, [_vm._v(_vm._s(group.totalInflows.toFixed(2)))]), _vm._v(" "), _c('th', {
      staticClass: "number col-amounts"
    }, [_vm._v(_vm._s(group.totalOutflows.toFixed(2)))]), _vm._v(" "), _c('th', {
      staticClass: "number col-amounts"
    }, [_vm._v(_vm._s(group.totalBalance.toFixed(2)))])])]), _vm._v(" "), _c('draggable', {
      attrs: {
        "element": "tbody",
        "options": {
          handle: '.sort-row'
        }
      },
      on: {
        "update": function($event) {
          _vm.autoSave(group.categories, 'budget', 'save-order')
        }
      },
      model: {
        value: (group.categories),
        callback: function($$v) {
          group.categories = $$v
        },
        expression: "group.categories"
      }
    }, _vm._l((group.categories), function(cat) {
      return _c('tr', [_c('td', {
        staticClass: "td-indent btn-col has-control"
      }, [(cat.description != 'Surplus' && _vm.budgetEditable) ? _c('i', {
        staticClass: "fa fa-fw fa-arrows icon-button sort-row"
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "td-indent",
        class: {
          'has-control': cat.descEditable && cat.description != 'Surplus'
        }
      }, [_c('a', {
        attrs: {
          "href": cat.link
        }
      }, [_vm._v(_vm._s(cat.description))])]), _vm._v(" "), _c('td', {
        staticClass: "number",
        class: {
          'has-control': _vm.budgetEditable
        }
      }, [(cat.description != 'Surplus' && _vm.budgetEditable) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cat.amount_alloc),
          expression: "cat.amount_alloc"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "0.01",
          "name": "amount_alloc",
          "placeholder": "$ 0.00"
        },
        domProps: {
          "value": (cat.amount_alloc)
        },
        on: {
          "change": function($event) {
            _vm.autoSave(cat, 'budget', 'save')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            cat.amount_alloc = $event.target.value
          },
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      }) : _c('div', [_vm._v(_vm._s(cat.amount_alloc ? parseFloat(cat.amount_alloc).toFixed(2) : ''))])]), _vm._v(" "), _c('td', {
        staticClass: "bg-info number"
      }, [_vm._v(_vm._s(cat.carryOver ? cat.carryOver.toFixed(2) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "bg-success number"
      }, [_vm._v(_vm._s(cat.inflowsAndIncome ? cat.inflowsAndIncome.toFixed(2) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "bg-outflows number"
      }, [_vm._v(_vm._s(cat.outflows ? parseFloat(cat.outflows).toFixed(2) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "bg-info number",
        class: {
          'text-danger': cat.balanceAfterInjection < 0
        }
      }, [_vm._v(_vm._s(cat.balanceAfterInjection < 0 ? '(' + cat.balanceAfterInjection.toFixed(2) + ')' : cat.balanceAfterInjection.toFixed(2)))])])
    }))], 1)
  }))], 1)]), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('ModalDialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText
    },
    on: {
      "confirm": function($event) {
        _vm.confirmationDialogResponse(true)
      },
      "closeModal": function($event) {
        _vm.confirmationDialogResponse(false)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmDialog.message) + "\n\t")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "btn-col"
  }), _vm._v(" "), _c('th', [_vm._v("Income Source")]), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "btn-col"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37f55e4f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BudgetManager.vue
// module id = 160
// module chunks = 1